// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1zIKJ","rootSmall":"AddTileButton_rootSmall__1i3eT"};